/* @flow */

import React from 'react';
import {connect} from 'react-redux';
import {changeDeviceSettings} from '../../../common/device/actions';

class PinLockTimeout extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        logoutTimer: React.PropTypes.number,
        logoutTimerOptions: React.PropTypes.object,
        changeDeviceSettings: React.PropTypes.func,
        openPopup: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.openPopup = this.openPopup.bind(this);
    }

    openPopup() {
        const {openPopup} = this.props;
        openPopup();
    }

    render() {
        const {logoutTimer, logoutTimerOptions, changeDeviceSettings, msg} = this.props;

        return (
            <div className="table-row">
              <div className="table-cell" style={{width: '55.55%'}}>
                <div className="boxBtn text-left text-black">
                    <div className="boxBtn-inner">
                      <div className="settings-name">
                        <span>{msg.settings.autoLock.title}</span>
                      </div>
                    </div>
                </div>
              </div>
              <div className="table-cell" style={{width: '44.44%'}}>
                    <div className="switch">
                        <div className={`switch-option text-l ${logoutTimer !== null ? 'active' : ''} color-greenLight`}
                             onClick={this.openPopup}>
                            <div className="switch-inner">
                                {logoutTimer === null &&
                                    <span>{msg.settings.allow}</span>
                                }
                                {logoutTimer !== null &&
                                    <span>{logoutTimerOptions.get(logoutTimer)}</span>
                                }
                            </div>
                        </div>
                        <div className={`switch-option text-l ${logoutTimer === null ? 'active' : ''} color-red`}
                             onClick={() => changeDeviceSettings('logoutTimer', null)}>
                            <div className="switch-inner">
                                <span>{msg.settings.deny}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    logoutTimer: state.device.logoutTimer,
    logoutTimerOptions: state.device.logoutTimerOptions
}), {changeDeviceSettings})(PinLockTimeout);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/PinLockTimeout.js